import React, { useEffect, useState, useRef } from "react";
import styles from "./index.module.scss";
import closeImg from "../../assets/images/close.png";

const CustomDropDown = ({
  className = "",
  value = "",
  input = {},
  options = [],
  onSelect = () => {},
  onFocus = () => {},
  crossButtonPosition = "",
}) => {
  const [searchTerm, setSearchTerm] = useState(value);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const inputRef = useRef(null); // Create a reference for the input

  useEffect(() => {
    let findSearchIndex = options.findIndex((option) => option === searchTerm);
    if (findSearchIndex === -1) {
      onSelect("");
    }
  }, [searchTerm]);

  useEffect(() => {
    setSearchTerm(value);
  }, [value]);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownOpen(true);
  };

  const handleOptionClick = (option) => {
    setSearchTerm(option);
    onSelect(option);
    setIsDropdownOpen(false);
  };

  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleClear = (e) => {
    e.stopPropagation(); // Prevent dropdown from closing when the clear button is clicked
    setSearchTerm("");
    onSelect("");
    inputRef.current?.focus(); // Focus the input when clear is clicked
    setTimeout(() => {
      setIsDropdownOpen(true);
    }, 500);
  };

  return (
    <div className={styles.container}>
      <input
        id={input.name}
        name={input.name}
        required={input.required}
        className={className}
        type="text"
        value={searchTerm}
        onChange={handleInputChange}
        onClick={() =>
          !isDropdownOpen ? setIsDropdownOpen(!isDropdownOpen) : null
        }
        placeholder={input.placeholder}
        autoComplete={"off"}
        onFocus={onFocus}
        onBlur={() => setTimeout(() => setIsDropdownOpen(false), 500)}
        ref={inputRef} // Attach the ref to the input
      />
      {searchTerm && (
        <img
          src={closeImg}
          alt="Clear"
          onClick={handleClear} // Prevent dropdown toggle here
          className={styles.clearButton}
          style={crossButtonPosition.length>1 ? {bottom: crossButtonPosition} : {}}
        />
      )}
      {isDropdownOpen && (
        <ul className={styles.dropDownContainer}>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <li
                key={option}
                onClick={() => handleOptionClick(option)}
                className={styles.dropDownitem}
              >
                {option}
              </li>
            ))
          ) : (
            <li className={styles.noData}>No results found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default CustomDropDown;
